import { Badge, BadgeProps } from 'react-bootstrap';

import React from 'react';
import styled from 'styled-components';

interface StatusBadgeProps extends BadgeProps {
    status?: number;
}

const StyledBadge = styled(Badge)`
    padding: 0.5rem 1rem;
    font-weight: 500;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-1px);
    }
`;

export const StatusBadge: React.FC<StatusBadgeProps> = (props) => {
    if (!props.status && props.status !== 0) {
        return null;
    }

    let text = '';
    let variant = '';
    switch (props.status) {
        case 0:
            text = 'Розглядається';
            variant = 'primary';
            break;
        case 1:
            text = 'Підтверджено';
            variant = 'success';
            break;
        case 2:
            text = 'Редагування';
            variant = 'warning';
            break;
        case 3:
            text = 'Не підтверджено';
            variant = 'danger';
            break;
    }

    return (
        <StyledBadge variant={variant} {...props}>
            {text}
        </StyledBadge>
    );
};
